import React, { useState, useEffect, useRef } from "react";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import { Card, Grid, IconButton, Tooltip } from "@mui/material";
import DataTable from "examples/Tables/DataTable";
import { get, post, put, delNoResponse } from "utils/WebService";
import Icon from "@mui/material/Icon";
import Swal from "sweetalert2";
import { useMaterialUIController } from "context";

function ReportsCustom() {
    const [controller] = useMaterialUIController();
    const { darkMode } = controller;
    const [reports, setReports] = useState([]);
    const [editingReport, setEditingReport] = useState(null);
    const [loading, setLoading] = useState(false);
    const tableState = useRef({});
    const fetchData = () => {};

    useEffect(() => {
        loadReports();
    }, []);

    const loadReports = async () => {
        setLoading(true);
        try {
            const res = await get("/relatorio-customizado");
            setReports(res.data || res || []);
        } catch (error) {
            Swal.fire("Erro", "Falha ao carregar relatórios", "error");
        }
        setLoading(false);
    };

    const handleSave = async () => {
        if (!editingReport.ccNome || !editingReport.ccQuerySql) {
            Swal.fire("Aviso", "Nome e SQL são obrigatórios", "warning");
            return;
        }
        try {
            if (editingReport.cvId) {
                await put(`/relatorio-customizado/${editingReport.cvId}`, editingReport);
                Swal.fire("Sucesso", "Relatório atualizado!", "success");
            } else {
                await post("/relatorio-customizado", editingReport);
                Swal.fire("Sucesso", "Relatório criado!", "success");
            }
            setEditingReport(null);
            loadReports();
        } catch (error) {
            Swal.fire("Erro", "Falha ao salvar relatório", "error");
        }
    };

    const handleDelete = async (id) => {
        const result = await Swal.fire({
            title: "Tem certeza?",
            text: "Você não poderá reverter isso!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Sim, excluir!",
            cancelButtonText: "Cancelar"
        });
        if (result.isConfirmed) {
            try {
                await delNoResponse(`/relatorio-customizado/${id}`);
                Swal.fire("Excluído!", "Relatório excluído com sucesso.", "success");
                loadReports();
            } catch (error) {
                Swal.fire("Erro", "Falha ao excluir", "error");
            }
        }
    };

    const columns = [
        { header: "ID", accessorKey: "cvId", size: 10 },
        { header: "Nome", accessorKey: "ccNome", size: 40 },
        { header: "Descrição", accessorKey: "ccDescricao", size: 30 },
        {
            header: "Ações",
            accessorKey: "actions",
            size: 20,
            cell: ({ row }) => (
                <MDBox display="flex" alignItems="center">
                    <Tooltip title="Editar">
                        <IconButton color="info" onClick={() => setEditingReport(row.original)}>
                            <Icon>edit</Icon>
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Excluir">
                        <IconButton color="error" onClick={() => handleDelete(row.original.cvId)}>
                            <Icon>delete</Icon>
                        </IconButton>
                    </Tooltip>
                </MDBox>
            ),
        },
    ];

    return (
        <Grid container display="flex" justifyContent="center">
            <Grid item xs={12} md={12}>
                <Card
                            variant="outlined"
                            sx={{
                                p: 2,
                                background: darkMode ? "#4B4F5C" : "#fff",
                                borderColor: darkMode ? "#333" : "#ddd",
                            }}
                        >
                            <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={2} p={1}>
                                <MDTypography variant="h5" color={darkMode ? "white" : "dark"}>
                                    {editingReport ? "Editar Relatório Customizado" : "Relatórios Customizados (Admin)"}
                                </MDTypography>
                                {!editingReport && (
                                    <MDButton variant="contained" color="dark" onClick={() => setEditingReport({ ccNome: "", ccDescricao: "", ccQuerySql: "" })}>
                                        <Icon sx={{ mr: 1 }}>add</Icon> Novo Relatório
                                    </MDButton>
                                )}
                            </MDBox>
                            <MDBox p={1}>
                                {editingReport ? (
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={6}>
                                            <MDInput
                                                label="Nome do Relatório"
                                                fullWidth
                                                value={editingReport.ccNome || ""}
                                                onChange={(e) => setEditingReport({ ...editingReport, ccNome: e.target.value })}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <MDInput
                                                label="Descrição"
                                                fullWidth
                                                value={editingReport.ccDescricao || ""}
                                                onChange={(e) => setEditingReport({ ...editingReport, ccDescricao: e.target.value })}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <MDInput
                                                label="Query SQL (ex: SELECT * FROM Tabela WHERE dtCriacao >= :startDate AND idUsuario IN (:userIds) )"
                                                fullWidth
                                                multiline
                                                rows={10}
                                                value={editingReport.ccQuerySql || ""}
                                                onChange={(e) => setEditingReport({ ...editingReport, ccQuerySql: e.target.value })}
                                            />
                                        </Grid>
                                        <Grid item xs={12} display="flex" justifyContent="flex-end">
                                            <MDButton color="secondary" onClick={() => setEditingReport(null)} sx={{ mr: 2 }}>
                                                Cancelar
                                            </MDButton>
                                            <MDButton color="info" onClick={handleSave}>
                                                Salvar Relatório
                                            </MDButton>
                                        </Grid>
                                    </Grid>
                                ) : (
                                    <DataTable
                                        columnData={columns}
                                        data={reports}
                                        tableState={tableState}
                                        fetchData={fetchData}
                                        showTotalEntries={false}
                                        noEndBorder
                                    />
                                )}
                            </MDBox>
                        </Card>
            </Grid>
        </Grid>
    );
}

export default ReportsCustom;
